import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const FILTER_KEY = 'quick_filter_price';

export const useQuickFilterSectionPriceOpenedState = () => {
  return useOpenedStateManager(FILTER_KEY);
};
